import {
  Box,
  IconButton,
  ModalHeader as ChakraUiModalHeader,
} from '@chakra-ui/react';
import type { FC } from 'react';
import { When } from 'react-if';

import Container from '@/components/Container';
import AngleLeftIcon from '@/components/Icon/AngleLeft';

import type { ModalHeaderProps } from './types';
import { colors } from '@/styles/theme/constants';

const ModalHeader: FC<ModalHeaderProps> = ({
  title,
  showed,
  handleBack,
  action,
}) => {
  return (
    <ChakraUiModalHeader
      px="24px"
      py="16px"
      minH={'56px'}
      display={showed ? 'flex': 'none'}
      alignItems={'center'}
      borderBottom={showed ? '1px' : 0}
      borderColor={colors.shade06}
      data-testid="modal_header"
    >
      <When condition={showed}>
        <Container
          display="flex"
          alignItems="center"
          height="auto"
          marginInlineStart="unset"
          marginInlineEnd="unset"
          margin={0}
        >
          <When condition={!!handleBack}>
            <IconButton
              data-testid="modal_header_buttonBack"
              aria-label="Back"
              variant="unstyled"
              onClick={handleBack}
              icon={<AngleLeftIcon />}
              minWidth="unset"
              minHeight="unset"
              height="auto"
              mr="8px"
            />
          </When>
          <Box
            fontFamily="lato"
            fontWeight={900}
            lineHeight="23px"
            color={colors.shade01}
            fontSize="18px"
            data-testid="modal_header_title"
          >
            {title}
          </Box>
          <When condition={!!action}>
            <Box flex={1} />
            {action}
          </When>
        </Container>
      </When>
    </ChakraUiModalHeader>
  );
};

export default ModalHeader;
